import { SearchExpressionInputModel } from '../types/models';
import { UserDocument, UserDocumentModel } from '../types/UserDocument';
import { api } from './api';

export const getPeopleOfInterest = async (
  token: string
): Promise<UserDocument[]> => {
  try {
    const response = await api.get<UserDocumentModel>(
      '/v1/search/people-of-interest',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data.users;
  } catch (error) {
    console.error('People of Interest error:', error);
    return [];
  }
};

export const getSearchResults = async (
  model: SearchExpressionInputModel,
  token: string
): Promise<UserDocumentModel> => {
  try {
    const response = await api.post('/v1/search', model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching search results:', error);
    throw error;
  }
};

const RECENT_SEARCHES_KEY = 'recentSearches';

export const getRecentSearches = (): string[] => {
  return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || '[]');
};

export const addRecentSearch = (searchText: string) => {
  let recentSearches = getRecentSearches();
  if (!recentSearches.includes(searchText)) {
    recentSearches.unshift(searchText);
    if (recentSearches.length > 10) {
      recentSearches.pop();
    }
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearches));
  }
};

export const deleteRecentSearch = (index: number) => {
  let recentSearches = getRecentSearches();
  recentSearches.splice(index, 1);
  localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearches));
};
